import type { BadgeColor } from '@/components/ui/Badge';
import type { UserQuestionStatus } from '@/models/user-question';

// Das Backend speichert die Priorität als int (0 = keine, höher = wichtiger); die UI vergibt 0-3.
export const USER_QUESTION_PRIORITIES = [
  { value: 0, label: 'Keine', dot: 'bg-gray-400' },
  { value: 1, label: 'Niedrig', dot: 'bg-blue-500' },
  { value: 2, label: 'Mittel', dot: 'bg-yellow-400' },
  { value: 3, label: 'Hoch', dot: 'bg-red-500' },
];

// Werte über 3 kann die API liefern, die UI zeigt sie als "Hoch"
export function clampPriority(priority: number | undefined): number {
  return Math.min(priority ?? 0, USER_QUESTION_PRIORITIES.length - 1);
}

export function getUserQuestionStatusLabel(status: UserQuestionStatus): string {
  return status === 'DONE' ? 'Erledigt' : 'Offen';
}

export function getUserQuestionStatusColor(status: UserQuestionStatus): BadgeColor {
  return status === 'DONE' ? 'green' : 'yellow';
}
